export enum RSVPDialogStep {
  RSVP = 'RSVP',
  BRING_LIST = 'BRING_LIST',
  WISH_LIST = 'WISH_LIST',
  QUESTIONNAIRE = 'QUESTIONNAIRE',
  PLUS_ONES = 'PLUS_ONES',
}
